import React, { useState } from "react";
import { Link } from "react-router-dom";
import unn from "../../data/unn.png";
import "../Admin/index.css";
import { API_BASE_URL, authFetch } from "../../config/api";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return setError("Please enter your email address.");
    setLoading(true);
    setError("");
    try {
      const res = await authFetch(`${API_BASE_URL}/api/users/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const json = await res.json();
      if (json.success) setSent(true);
      else setError(json.error || "Something went wrong.");
    } catch {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin_login">
      <div className="admin_login_logos">
        <div className="admin_login_logo">
          <img src={unn} alt="unn_logo" />
        </div>
      </div>
      <div className="admin_login_title">
        <h1>Faculty of Pharmaceutical Sciences</h1>
        <h2>University of Nigeria Nsukka</h2>
      </div>
      <h2>Forgot Password</h2>
      {sent ? (
        <div style={{ textAlign: "center", maxWidth: "22rem" }}>
          <p>If that email exists in our system, a reset link has been sent. Check your inbox.</p>
          <Link to="/admin" className="admin_login_forgot">Back to Sign In</Link>
        </div>
      ) : (
        <form className="admin_login_form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && <p style={{ color: "red", fontSize: "0.85rem" }}>{error}</p>}
          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
          <Link to="/admin" className="admin_login_forgot">Back to Sign In</Link>
        </form>
      )}
    </div>
  );
}

export default ForgotPassword;
